<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line" >
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">接警人：</span>
        </div>
        <el-select v-model="formData.personCode"
                   filterable
                   remote
                   disabled
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="personRemoteMethod"
                   placeholder="请输入关键词查询">
          <el-option v-for="item in personList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line" >
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">报警类别：</span>
        </div>
        <el-select v-model="alarmType" multiple placeholder="请选择" size="small" style="width: 280px">
          <el-option
            v-for="item in alarmTypeList"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </div>


      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import $ from 'jquery'
  import {api} from '../../api/Alarm'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'
  import UploadImgList from '../../../components/Input/UploadImgList'
  import Clipboard from 'clipboard'

  export default {
    components: {
      UploadImgList,
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'police-receiver-modify',
    data () {
      return {
        breadcrumb: [{
          value: '报警中心',
          name: 'alarm-device-manage'
        }, {
          value: '接警人管理'
        }],
        mainTitle: '修改接警人',
        subheading: '',

        formData: {
          personCode: '',
          alarmType: ''
        },

        personCode: '',
        personList: [],
        alarmType: '',
        alarmTypeList: [
          {code: '液位报警', name: '液位报警'},
          {code: '液压报警', name: '液压报警'},
          {code: '烟感报警', name: '烟感报警'},
        ],
      }
    },
    created () {
      this.getAlarmHandleManByCode(this.$route.params.id)
      this.getResponsiblePersonList()
    },
    methods: {
      // 查询接警人信息
      getAlarmHandleManByCode (code) {
        this.$axios.get(`${api.getAlarmHandleManByCode}/${code}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let resData = res.data.data
              this.formData = resData
              this.alarmType = this.formData.alarmType.split(',')
              this.personRemoteMethod(this.formData.personCode)
            }
          })
          .catch(errorHandler('查询失败'))
      },
      personRemoteMethod (query) {
        this.getResponsiblePersonList(query)
      },
      // 获取人员列表
      getResponsiblePersonList (query) {
        this.$axios.post(api.getResponsiblePersonList, {
          searchKey: query || ''
        })
          .then(res => {
            if (res.data.retCode === 1) {
              this.personList = res.data.data
            }
          })
          .catch(errorHandler('获取人员列表失败'))
      },

      toManagePage () {
        this.$router.push({
          name: 'police-receiver'
        })
      },

      confirm () {
        if (!this.formData.personCode) {
          nError('请选择报警人')
          return false
        }
        if (this.alarmType.length === 0) {
          nError('请选择报警类别')
          return false
        }
        this.formData.alarmType = this.alarmType.join(',')
        this.$axios.post(api.updateAlarmHandleMan, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('修改成功')
              this.toManagePage()
            }
          })
          .catch(errorHandler('修改失败'))
      },
      cancel () {
        this.toManagePage()
      },
    },
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 140px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 36px;
    line-height: 120px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 50px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .el-switch {
    height: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/view/AlarmManage/PoliceReceiver/PoliceReceiverModify.vue